import { render, staticRenderFns } from "./recycle_bin_table.vue?vue&type=template&id=57eb4e80&scoped=true&"
import script from "./recycle_bin_table.vue?vue&type=script&lang=js&"
export * from "./recycle_bin_table.vue?vue&type=script&lang=js&"
import style0 from "./recycle_bin_table.vue?vue&type=style&index=0&id=57eb4e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb4e80",
  null
  
)

export default component.exports